<template>
  <div id="ordering-report-view">
    <div v-if="gettingReportCompleted && report.length > 0" class="report-data-container">
      <div v-for="product in report" :key="product.product_id" class="product-wrap">
        <div>
          <div class="product-info">
            <img v-if="product.BarcodeImg" :src="`data:image/png;base64,${product.BarcodeImg}`" class="barcode-img">
            <p v-if="!product.BarcodeImg" class="missing-img-slug">[CAN'T GENERATE BARCODE IMAGE]</p>
            <div class="product-text-info">
              <p>{{ product.product_id }}</p>
              <p>{{ product['Product Name'] }}</p>
              <p>{{ product['Product Description'] }}</p>
              <p>Actual order: {{ product.ActualOrder }}</p>
            </div>
          </div>
          <v-divider class="ht my-5 grey lighten-1"></v-divider>
        </div>
        <v-divider inset vertical class="mx-4 grey"></v-divider>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Vue from 'vue';
export default {
  computed: {
    ...mapState('ordering', [
      'report',
      'gettingReport',
      'gettingReportCompleted',
      'gettingReportError',
    ]),
  },
  created() {
    Vue.nextTick(() => {
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                            'July', 'August', 'September', 'October', 'November', 'December'
                         ];
        document.title = this.$route.query.supplier + ' , ' + monthNames[this.$route.query.month] + ' , ' +  this.$route.query.period + ' months order';
    });
    this.$store.dispatch('ordering/getOrderingReport', this.$route.params.reportEntityId);
  }
};
</script>


<style>

.report-data-container {
  display: flex;
  flex-flow: row wrap;
  max-width: 100%;
}

.product-info {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 460px;
}

.barcode-img, .missing-img-slug {
  width: 360px;
  height: 236px;
  margin: 0;
  object-fit: cover;
}

/*
.product-text-info p:first-child {
  margin-top: 15px;
}
*/

.product-info p {
  font-size: 12pt;
  margin-bottom: 0;
}

.product-wrap {
  display: flex;
}

.report-data-container .v-divider--vertical {
  max-height: calc(100% + 1px) !important;
  height: calc(100% + 1px) !important;
  margin-top: -21px;
}

.report-data-container .v-divider.ht {
  width: calc(100% + 31px);
  max-width: calc(100% + 31px);
  margin-left: -15px !important;
}

#ordering-report-view {
  margin-left: -16px;
  margin-top: -1px;
}

</style>



// WEBPACK FOOTER //
// src/views/OrderingReport.vue